import { z } from 'zod';
import { brokerPageContent, whatsappTemplates } from './broker.js';
import { emailLower, httpUrl, phoneE164, phoneInput, slug } from './common.js';
import { brokerStatus } from './enums.js';

// PATCH /broker/me/profile · broker updates their own profile.
export const brokerProfileUpdateInput = z
  .object({
    name: z.string().trim().min(2).max(120).optional(),
    phone: phoneInput.optional(),
    whatsappNumber: phoneInput.optional(),
    bio: z.string().max(1000).optional(),
    avatarUrl: httpUrl.optional(),
  })
  .strict();

export type BrokerProfileUpdateInput = z.infer<typeof brokerProfileUpdateInput>;

// PATCH /broker/me/page-content · partial update of pageContent.
export const brokerPageContentUpdateInput = brokerPageContent.partial();
export type BrokerPageContentUpdateInput = z.infer<typeof brokerPageContentUpdateInput>;

// PATCH /broker/me/whatsapp-templates
export const brokerWhatsappTemplatesUpdateInput = whatsappTemplates;
export type BrokerWhatsappTemplatesUpdateInput = z.infer<
  typeof brokerWhatsappTemplatesUpdateInput
>;

// POST /admin/brokers · admin creates a new broker (creates Firebase user too).
export const adminCreateBrokerInput = z
  .object({
    name: z.string().trim().min(2).max(120),
    email: emailLower,
    password: z.string().min(8).max(72),
    subdomain: slug.min(2).max(30),
    phone: phoneInput,
    whatsappNumber: phoneInput,
    bio: z.string().max(1000).optional(),
  })
  .strict();

export type AdminCreateBrokerInput = z.infer<typeof adminCreateBrokerInput>;

// PATCH /admin/brokers/:id · admin updates broker meta.
export const adminUpdateBrokerInput = z
  .object({
    name: z.string().trim().min(2).max(120).optional(),
    phone: phoneE164.optional(),
    whatsappNumber: phoneE164.optional(),
    status: brokerStatus.optional(),
    /**
     * Override do content_category enviado no Meta CAPI. Vazio (string vazia
     * ou undefined) limpa o override · volta a usar o default da vertical.
     */
    metaContentCategory: z
      .string()
      .trim()
      .max(80)
      .regex(/^[a-z0-9_]*$/, 'Use apenas letras minúsculas, números e _')
      .optional(),
  })
  .strict();

export type AdminUpdateBrokerInput = z.infer<typeof adminUpdateBrokerInput>;
